module.exports = __webpack_public_path__ + "static/media/profile.4a4452f8.jpg";